// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Inter', sans-serif;
}
.dark-theme{
  --bodyColor:#161625;
  --inputColor:#1e1e30;
  --cardBgColor:#1e1e30;
  --stateTableColor :#1e1e30;
  --clientTableColor:#1e1e30;
  --districtTableColor:#1e2a3b;
  --clientTableHead:#1e1e30
  
}

.light-theme{
  --bodyColor:white;
  --inputColor:white
  --cardBgColor:white;
  --stateTableColor :#f6f6f7;
  --districtTableColor:aliceblue;
  --clientTableColor:rgb(216 221 233);
  --clientTableHead:rgb(229 231 235)
}



.App {
  text-align: center;
}

body{
  background-color:  var(--bodyColor) !important
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.leaflet-container {
  width: 100%;
  height: 100vh;
}






.home{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr)) ;

}


@media screen and (max-width:1220px) {
  .home{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .cards{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .map-tool{
    padding: 0px 10px;
  }

  body{
    /* font-size: 8px ; */
  }

  .table{
    width: 100%;
    overflow-x: scroll;
  }

  .cards-main {
    width: 100% !important;
  }

  .client-table{
    width: 100%;
    overflow-x: scroll;
  }
}

@media screen and (max-width:440px) {



  .table-head{
    width: 600px;
    /* padding: 0px; */
  }

  .table-body{
    width: 600px;
  }

  .map{
    padding-left:50px !important ;
  }

  .modality-check{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    font-size: 10px !important;
  }

  .map-tool-div>div:nth-child(3){
    width: 80px !important;
  }

  .map-tool-div>div:nth-child(3)>div:nth-child(2) {
    font-size: 20px !important;
  }

  h1{
    font-size: 15px !important ;
  }

  .map-tool-detail>div{
    font-size: 15px !important;
  }


  .client-table-head{
    width: 600px;
    /* padding: 0px; */
  }

  .client-table-body{
    width: 600px;
  }

  .monthly-stats>div{
    margin-left:10px !important;
  }

  .monthly-stats{
    margin-left:10px !important;
  }

  .weekly-data>div{
    margin-left: 10px !important;
  }


  .client-seacrh>div{
    margin-left: -120px !important;
    margin-top: 15px;
  }

  .header-tab{
    display: grid !important;
    grid-template-columns:repeat(6, minmax(0, 1fr)) ;

  }

  .header-tab>div:nth-child(1){
    grid-column: span 1;
    
  }

  .header-tab>div:nth-child(2){
    width: 100% !important;
    margin-left: 0px !important;
    grid-column: span 5;
  }
  .header-tab>div:nth-child(3){
    flex-direction: column !important;
    justify-content: start !important;
    align-items: start !important;
  }

  .header-tab>div:nth-child(3)>div{
     margin: 6px 0px ;
  }

  .contribution-first-table>div {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }

  .contribution-first-table>div>div:nth-child(2){
    margin-left: 10px !important;
    margin-right: 10px !important;
  }

  .date-ranger{
    margin-left: 10px !important;
    margin-right: 10px !important;
    flex-direction: column;
  }

  .date-ranger>div{
    margin-bottom: 10px !important;
  }

  .date-ranger>div:nth-child(1){
    font-size: 15px !important;
  }

  .contribution-first-table>div>div:nth-child(2)>div:nth-child(1) {
    width: 100px !important;
  }

  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels{
    flex-direction: column;
  }

  .table-map-state .ant-table-cell-fix-left {
    position: inherit  !important;
  }


  

  .contribution-first-table>div>div:nth-child(2)>div:nth-child(1)>div {
    width: 100px !important;
    font-size: 10px !important;
  }

  .weekly-data>div>div{
    font-size: 10px !important;
    height: 47px !important;
    
  }

  .weekly-data>div>div>div:nth-child(2){
    font-size: 8px !important;
  }

  .monthly-stats>div>div>div{
    font-size: 10px !important;
    height: 47px !important;
    
  }

  .monthly-stats>div>div>div>div:nth-child(2){
    font-size: 8px !important;
  }


}




.Search input{
  background: var(--inputColor) !important;
}


.box{
  background: var(--cardBgColor);
}

.table-head>div{
   background: var(--stateTableColor);
}

.client-table-head>div{
  background: var(--clientTableHead);
  border-right: 1px solid var(--clientTableColor)
}

.client-table-body::-webkit-scrollbar {
  width: 0; 
}

.client-table-body::-webkit-scrollbar-thumb {
  background: transparent;
}

.table-body::-webkit-scrollbar {
  width: 0; 
}

.table-body::-webkit-scrollbar-thumb {
  background: transparent;
}

.district .table-body::-webkit-scrollbar {
  width: 0; 
}

.district .table-body::-webkit-scrollbar-thumb {
  background: none; 
}


.district >div{
  cursor: pointer;
}


.client-table-body>div>div:nth-child(1)>div:nth-child(1){
  background: var(--stateTableColor) !important;

}
.client-table-body>div:nth-child(2n)>div{
  background: var(--stateTableColor) !important;
}



.table-body>div>div:nth-child(1)>div:nth-child(1){
  background: var(--stateTableColor) !important;

}
.table-body>div:nth-child(2n)>div:nth-child(1)>div{
  background: var(--stateTableColor) !important;
}

.district .table-head>div{
  background: var(--districtTableColor);
}

.district .table-body>div>div:nth-child(1)>div:nth-child(1){
 background: var(--districtTableColor) !important;
}
.district .table-body>div:nth-child(2n)>div:nth-child(1)>div{
 background: var(--districtTableColor) !important;
}

.theme-selector {
  
  margin-top: 10px;
  margin-left: 10px;
  display: flex ;
  align-items: flex-start;
  /* flex-direction: ; */
  /* background-color: var(--districtTableColor); */
}

.theme-selector>div:nth-child(2){
  margin-left: 30px;
  font-weight: 600;
  color:  #6c757d;
  /* border: 1px solid var(--stateTableColor); */
  cursor: pointer;
}

.theme-selector svg{
  cursor: pointer;
  /* background-color: var(--districtTableColor); */
  /* padding: px; */
}

.client-table
{
  border: 1px solid var(--clientTableColor);
}


.input-search{
  background: var(--stateTableColor);
  /* border: none !important; */
}

.pagination{
  color:#6c757d ;
}

/* 
.login-form >div:nth-child(1){
  background: rgb(255, 240, 243);
  border-left: 5px solid rgb(255, 179, 192);
} */


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B;;AAEF;;AAEA;EACE,iBAAiB;EACjB;qBACmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,mCAAmC;EACnC;AACF;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;;;;;;AAOA;EACE,WAAW;EACX,aAAa;EACb,iDAAiD;;AAEnD;;;AAGA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;;;;EAIE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2DAA2D;IAI3D,0BAA0B;EAH5B;;EAMA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;;EAGA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,gDAAgD;;EAElD;;EAEA;IACE,mBAAmB;;EAErB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,iCAAiC;IACjC,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA;KACG,gBAAgB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;;;;EAKA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;;EAEzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;;EAEzB;;EAEA;IACE,yBAAyB;EAC3B;;;AAGF;;;;;AAKA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,8BAA8B;AAChC;;AAEA;GACG,kCAAkC;AACrC;;AAEA;EACE,kCAAkC;EAClC;AACF;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,6CAA6C;;AAE/C;AACA;EACE,6CAA6C;AAC/C;;;;AAIA;EACE,6CAA6C;;AAE/C;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;CACC,gDAAgD;AACjD;AACA;CACC,gDAAgD;AACjD;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;;EAEE,yCAAyC;AAC3C;;;AAGA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;GAIG","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;700&display=swap');\nbody {\n  margin: 0;\n  font-family: 'Inter', sans-serif;\n}\n.dark-theme{\n  --bodyColor:#161625;\n  --inputColor:#1e1e30;\n  --cardBgColor:#1e1e30;\n  --stateTableColor :#1e1e30;\n  --clientTableColor:#1e1e30;\n  --districtTableColor:#1e2a3b;\n  --clientTableHead:#1e1e30\n  \n}\n\n.light-theme{\n  --bodyColor:white;\n  --inputColor:white\n  --cardBgColor:white;\n  --stateTableColor :#f6f6f7;\n  --districtTableColor:aliceblue;\n  --clientTableColor:rgb(216 221 233);\n  --clientTableHead:rgb(229 231 235)\n}\n\n\n\n.App {\n  text-align: center;\n}\n\nbody{\n  background-color:  var(--bodyColor) !important\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.leaflet-container {\n  width: 100%;\n  height: 100vh;\n}\n\n\n\n\n\n\n.home{\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr)) ;\n\n}\n\n\n@media screen and (max-width:1220px) {\n  .home{\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .cards{\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n  .map-tool{\n    padding: 0px 10px;\n  }\n\n  body{\n    /* font-size: 8px ; */\n  }\n\n  .table{\n    width: 100%;\n    overflow-x: scroll;\n  }\n\n  .cards-main {\n    width: 100% !important;\n  }\n\n  .client-table{\n    width: 100%;\n    overflow-x: scroll;\n  }\n}\n\n@media screen and (max-width:440px) {\n\n\n\n  .table-head{\n    width: 600px;\n    /* padding: 0px; */\n  }\n\n  .table-body{\n    width: 600px;\n  }\n\n  .map{\n    padding-left:50px !important ;\n  }\n\n  .modality-check{\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n\n  .modality-check{\n    font-size: 10px !important;\n  }\n\n  .map-tool-div>div:nth-child(3){\n    width: 80px !important;\n  }\n\n  .map-tool-div>div:nth-child(3)>div:nth-child(2) {\n    font-size: 20px !important;\n  }\n\n  h1{\n    font-size: 15px !important ;\n  }\n\n  .map-tool-detail>div{\n    font-size: 15px !important;\n  }\n\n\n  .client-table-head{\n    width: 600px;\n    /* padding: 0px; */\n  }\n\n  .client-table-body{\n    width: 600px;\n  }\n\n  .monthly-stats>div{\n    margin-left:10px !important;\n  }\n\n  .monthly-stats{\n    margin-left:10px !important;\n  }\n\n  .weekly-data>div{\n    margin-left: 10px !important;\n  }\n\n\n  .client-seacrh>div{\n    margin-left: -120px !important;\n    margin-top: 15px;\n  }\n\n  .header-tab{\n    display: grid !important;\n    grid-template-columns:repeat(6, minmax(0, 1fr)) ;\n\n  }\n\n  .header-tab>div:nth-child(1){\n    grid-column: span 1;\n    \n  }\n\n  .header-tab>div:nth-child(2){\n    width: 100% !important;\n    margin-left: 0px !important;\n    grid-column: span 5;\n  }\n  .header-tab>div:nth-child(3){\n    flex-direction: column !important;\n    justify-content: start !important;\n    align-items: start !important;\n  }\n\n  .header-tab>div:nth-child(3)>div{\n     margin: 6px 0px ;\n  }\n\n  .contribution-first-table>div {\n    margin-right: 10px !important;\n    margin-left: 10px !important;\n  }\n\n  .contribution-first-table>div>div:nth-child(2){\n    margin-left: 10px !important;\n    margin-right: 10px !important;\n  }\n\n  .date-ranger{\n    margin-left: 10px !important;\n    margin-right: 10px !important;\n    flex-direction: column;\n  }\n\n  .date-ranger>div{\n    margin-bottom: 10px !important;\n  }\n\n  .date-ranger>div:nth-child(1){\n    font-size: 15px !important;\n  }\n\n  .contribution-first-table>div>div:nth-child(2)>div:nth-child(1) {\n    width: 100px !important;\n  }\n\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels{\n    flex-direction: column;\n  }\n\n  .table-map-state .ant-table-cell-fix-left {\n    position: inherit  !important;\n  }\n\n\n  \n\n  .contribution-first-table>div>div:nth-child(2)>div:nth-child(1)>div {\n    width: 100px !important;\n    font-size: 10px !important;\n  }\n\n  .weekly-data>div>div{\n    font-size: 10px !important;\n    height: 47px !important;\n    \n  }\n\n  .weekly-data>div>div>div:nth-child(2){\n    font-size: 8px !important;\n  }\n\n  .monthly-stats>div>div>div{\n    font-size: 10px !important;\n    height: 47px !important;\n    \n  }\n\n  .monthly-stats>div>div>div>div:nth-child(2){\n    font-size: 8px !important;\n  }\n\n\n}\n\n\n\n\n.Search input{\n  background: var(--inputColor) !important;\n}\n\n\n.box{\n  background: var(--cardBgColor);\n}\n\n.table-head>div{\n   background: var(--stateTableColor);\n}\n\n.client-table-head>div{\n  background: var(--clientTableHead);\n  border-right: 1px solid var(--clientTableColor)\n}\n\n.client-table-body::-webkit-scrollbar {\n  width: 0; \n}\n\n.client-table-body::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.table-body::-webkit-scrollbar {\n  width: 0; \n}\n\n.table-body::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.district .table-body::-webkit-scrollbar {\n  width: 0; \n}\n\n.district .table-body::-webkit-scrollbar-thumb {\n  background: none; \n}\n\n\n.district >div{\n  cursor: pointer;\n}\n\n\n.client-table-body>div>div:nth-child(1)>div:nth-child(1){\n  background: var(--stateTableColor) !important;\n\n}\n.client-table-body>div:nth-child(2n)>div{\n  background: var(--stateTableColor) !important;\n}\n\n\n\n.table-body>div>div:nth-child(1)>div:nth-child(1){\n  background: var(--stateTableColor) !important;\n\n}\n.table-body>div:nth-child(2n)>div:nth-child(1)>div{\n  background: var(--stateTableColor) !important;\n}\n\n.district .table-head>div{\n  background: var(--districtTableColor);\n}\n\n.district .table-body>div>div:nth-child(1)>div:nth-child(1){\n background: var(--districtTableColor) !important;\n}\n.district .table-body>div:nth-child(2n)>div:nth-child(1)>div{\n background: var(--districtTableColor) !important;\n}\n\n.theme-selector {\n  \n  margin-top: 10px;\n  margin-left: 10px;\n  display: flex ;\n  align-items: flex-start;\n  /* flex-direction: ; */\n  /* background-color: var(--districtTableColor); */\n}\n\n.theme-selector>div:nth-child(2){\n  margin-left: 30px;\n  font-weight: 600;\n  color:  #6c757d;\n  /* border: 1px solid var(--stateTableColor); */\n  cursor: pointer;\n}\n\n.theme-selector svg{\n  cursor: pointer;\n  /* background-color: var(--districtTableColor); */\n  /* padding: px; */\n}\n\n.client-table\n{\n  border: 1px solid var(--clientTableColor);\n}\n\n\n.input-search{\n  background: var(--stateTableColor);\n  /* border: none !important; */\n}\n\n.pagination{\n  color:#6c757d ;\n}\n\n/* \n.login-form >div:nth-child(1){\n  background: rgb(255, 240, 243);\n  border-left: 5px solid rgb(255, 179, 192);\n} */\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
